import React from 'react';
import logosx from '../assets/operaCharitas_logo.png';
import logocx from '../assets/Refal_logo.png';
import logodx from '../assets/caRezzonico_logo.png';
import { useMediaQuery } from 'react-responsive';

export default function Footer(props) {
    const isMobile = useMediaQuery({ query: '(min-width: 769px)' });
    return (
        <div style={{...styles.container, ...props.style}}>
            <div style={styles.imageContainer}>
                {isMobile && <img src={logosx} alt="footer 1" style={styles.imageSx}/>}
                <img src={logocx} alt="footer 1" style={styles.imageCx}/>
                {isMobile && <img src={logodx} alt="footer 1" style={styles.imageDx}/>}
            </div>
        </div>
    );
};
const styles = {
    container:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end',
        backgroundColor: '#fff',
        padding: '1rem 0rem',
        // marginBottom: 20,
        // marginTop: 20,
        width: '100%',
        height: 250,
        gap: 20,
    },
    imageContainer:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 20,
        height: '100%',
        width: '50%',
        maxWidth: '600px',
        marginTop: 20,
    },
    imageSx:{
        height: 'auto',
        width: 'auto',
        objectFit: 'scale-down',
    },
    imageCx:{
        height: 'auto',
        maxHeight: '200px',
        width: 'auto',
        objectFit: 'contain',
    },
    imageDx:{
        height: 'auto',
        width: 'auto',
        objectFit: 'scale-down',
    },
}